import {gsap} from "gsap";
import {ScrollTrigger} from 'gsap/ScrollTrigger'

export const commitments = () => {
  const
    animations = {
      accordions: () => import('./../animations/accordions'),
      enquire: () => import('./../animations/enquire'),
      revealTextByLine: () => import('./../animations/reveal-text-by-line'),
      scaleElWidth: () => import('./../animations/scale-element-width')
    },
    smoothScroller = document.querySelector('.smooth-scroll'),
    pinnedSections = document.querySelectorAll('.section-pinned'),
    accordionsGroup = document.querySelectorAll('.yacht__accordions'),
    toRevealTexts = document.querySelectorAll('.text-reveal'),
    ecoIcons = document.querySelectorAll('.eco-icon'),
    toScaleWidthElements = document.querySelectorAll('.scale-width > div'),
    splitAndRevealText = () => {
      if (toRevealTexts.length > 0) {
        animations.revealTextByLine().then(module => {
          for (const text of toRevealTexts) {
              module.revealTextByLine(text)
          }
        })
      }
    }

  if (pinnedSections.length > 0) {
    for (const [index, section] of pinnedSections.entries()) {
      ScrollTrigger.matchMedia({
        /* 🖥 desktop pinned section animation */
        "(min-width: 1024px)": function () {
          ScrollTrigger.create({
            scroller: smoothScroller,
            trigger: section,
            start: 'top 54',
            end: index === pinnedSections.length ? 'bottom top' : smoothScroller.scrollHeight,
            pin: true,
            scrub: true,
            pinSpacing: index === pinnedSections.length
          })
        }
      })
    }
  }

  if (accordionsGroup.length > 0) {
    for (const group of accordionsGroup) {
      const accordions = group.querySelectorAll('.yacht__accordion')

      if (accordions.length > 0) {
        for (const [i, accordion] of accordions.entries()) {
          let isOpen = false

          const trigger = accordion.querySelector('.yacht__accordion__trigger'),
            container = accordion.querySelector('.yacht__accordion__content');

          trigger.addEventListener('click', () => {
            isOpen = !isOpen

            animations.accordions().then(module => {
              module.accordions(isOpen, container, .7, null, null, null, trigger)
              accordion.classList.toggle('yacht__accordion--open')
            })
          })
        }
      }
    }
  }

  if (ecoIcons.length > 0) {
    for (const icon of ecoIcons) {
      gsap.to(icon, {
        y: 0,
        delay: .05,
        scrollTrigger: {
          scroller: smoothScroller,
          trigger: icon,
          start: 'top 80%',
          once: true,
        }
      })
    }
  }

  if (toScaleWidthElements.length > 0) {
    animations.scaleElWidth().then(module => {
      for (const element of toScaleWidthElements) {
        const cover = element.querySelector('.scale-width__cover')
        const isIntro = element.getAttribute("data-scale") === "intro" ? true : false
        module.scaleWidth(element, cover ? cover : null, isIntro ?  "top "+element.parentNode.offsetTop : "top 80%", !isIntro)
      }
    })
  }

  splitAndRevealText()

  animations.enquire().then(module => module.enquire())
}
